import { createAsyncThunk } from '@reduxjs/toolkit'
import ProcessedBranding from './processed-branding-model'
import {
  delete_processedBranding,
  load_processedBrandings,
  store_processedBranding,
} from './processedBranding-service'

export const LoadProcessedBrandingsAsync = createAsyncThunk<any, any>(
  'composer/load/processedBranding',
  async (params: { uid: string }) => {
    return await load_processedBrandings(params)
  },
)

export const CreateProcessedBrandingAsync = createAsyncThunk<any, any>(
  'composer/create/processedBranding',
  async (params: ProcessedBranding) => {
    return await store_processedBranding(params)
  },
)

export const DeleteProcessedBrandingAsync = createAsyncThunk<any, any>(
  'composer/delete/processedBranding',
  async (params) => {
    return await delete_processedBranding(params)
  },
)
